export const CMS_APP_DEF_ID = 'e593b0bd-b783-45b8-97c2-873d42aacaf4'
